<template>
    <div id="deck">
        <iframe :style="`height:${width > (height*16)/9 ? height : (width*9)/16}px; width:${width > (height*16)/9 ? (height*16)/9 : width}px; ${width > (height*16)/9 ? '' : `margin-top: ${height/2 - ((width*9)/16)/2}px` }`" class="typeform-widget" data-hj-allow-iframe="true" allow="fullscreen" allowfullscreen=""
             :src="`https://app.pitch.com/app/embed/${deck}`"></iframe>
    </div>
</template>

<script>
    export default {
      name: 'deck',
      props: ['deck'],
      data () {
        return {
          width: document.documentElement.clientWidth,
          height: document.documentElement.clientHeight,
        }
      },
      metaInfo() {
        return {

          title: this.title,
          meta: [
            {hid: 'viewport', content: 'width=device-width, viewport-fit=cover, initial-scale=1, user-scalable=no', name: 'viewport'},
            {property: 'og:title', content: this.title},
            {property: 'og:site_name', content: '🌀SPIRITT | The New Standard in How to Start a Start-Up'},
            {property: 'og:description', content: 'Build A Gorgeous App By Only Describing It'},
            {property: 'og:type', content: 'website'},
            {property: 'og:image', content: `https://document-sync-4-prod.api.pitch.com/preview-image/${this.deck}`},
            {property: 'og:image:width', content: '600'},
            {property: 'og:image:height', content: '315'},

            // Twitter card
            {property: 'twitter:card', content: 'summary'},
            {property: 'twitter:title', content: this.title},
            {property: 'twitter:description', content: 'Build A Gorgeous App By Only Describing It'},

            {property: 'twitter:image:src', content: `https://document-sync-4-prod.api.pitch.com/preview-image/${this.deck}`},
            {property: 'twitter:image:width', content: '200'},
            {property: 'twitter:image:height', content: '200'},

            // Google / Schema.org markup:
            {name: 'robots', content: 'noindex, nofollow'},
            {name: 'name', content: 'SPIRITT'},
            {name: 'description', content: 'Build A Gorgeous App By Only Describing It'},
            {name: 'image', content: `https://document-sync-4-prod.api.pitch.com/preview-image/${this.deck}`},
          ],
        }
      },

      mounted() {
        document.querySelector('html').style.height = '100%';
        document.querySelector('body').style.height = '100%';
        document.querySelector('body').style.backgroundColor = '#000000';

        window.addEventListener('resize', () => {
          this.width = document.documentElement.clientWidth;
          this.height = document.documentElement.clientHeight;
        });
      },
      beforeDestroy() {
        document.querySelector('html').style.height = null;
        document.querySelector('body').style.height = null;
        document.querySelector('body').style.backgroundColor = null;
        window.removeEventListener('resize', () => {
          this.width = document.documentElement.clientWidth;
          this.height = document.documentElement.clientHeight;
        });
      }
    }
</script>

<style lang="css" scoped>
    #deck {
        background: #000000;
        position: relative;
    }
    .typeform-widget {
      border: none;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
</style>
